import { StickyNote } from "lucide-react";

import { cn } from "@/lib/utils";

import { useAgents } from "../useAgents";
import { noteAgo, type ContactNotes } from "./clientNotes";

/**
 * Latest team note in one or two lines (lists and board cards), so you know
 * there is something to read before opening the client.
 */
export const NotePreview = ({
  notes,
  lines = 1,
  onClick,
  className,
}: {
  notes: ContactNotes;
  lines?: 1 | 2;
  onClick?: () => void;
  className?: string;
}) => {
  const { nameOf } = useAgents();
  const [latest] = notes.team;
  if (!latest) return null;
  const more = notes.team.length - 1;
  const author = nameOf(latest.sales_id).split(" ")[0];
  return (
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        onClick?.();
      }}
      title={latest.text ?? undefined}
      className={cn(
        "flex w-full items-start gap-1.5 rounded-lg border border-amber-200 bg-amber-50 px-2 py-1 text-left text-xs text-neutral-800 transition-colors hover:bg-amber-100 dark:border-amber-500/30 dark:bg-amber-400/10 dark:text-amber-50 dark:hover:bg-amber-400/15",
        className,
      )}
    >
      <StickyNote className="mt-0.5 h-3.5 w-3.5 shrink-0 text-amber-600 dark:text-amber-400" />
      <span className="min-w-0 flex-1">
        <span
          className={cn(
            "break-words",
            lines === 1 ? "line-clamp-1" : "line-clamp-2",
          )}
        >
          {latest.text}
        </span>
        <span className="block text-[11px] text-amber-900/60 dark:text-amber-200/60">
          {author ? `${author} · ` : ""}
          {noteAgo(latest.date)}
          {more > 0 ? ` · +${more} nota${more === 1 ? "" : "s"}` : ""}
        </span>
      </span>
    </button>
  );
};
